// extracted by mini-css-extract-plugin
export default {"root":"_10s1e","label":"_1VGg0","value":"_1su2N"};